const en = {
  drivers: {
    edit: "Edit driver",
    new: "New driver",
    singular: "Driver",
    plural: "Drivers",
    delete: "Delete driver",

    questions: {
      delete: "Do you really want to delete this driver?",
    },
  },

  subsidiaries: {
    delete: "Delete subsidiary",
    edit: "Edit subsidiary",
    new: "New subsidiary",
    singular: "Subsidiary",
    plural: "Subsidiaries",
    versions: "Subsidiary versions",

    questions: {
      delete: "Do you really want to delete this subsidiary?",
    },

    errors: {
      notMatchingSubsidiaryFound: "No matching subsidiary found.",
      nameAlreadyExists: "Subsidiary name already used",
      countryISOCodeAlreadyExists: "The specified country iso code is already defined for another subsidiary.",
      inUseByCars: "The subsidiary is still in use by cars and can't be deleted.",
      inUseByCarOrders: "Subsidiary is still in use by a car orders and can't be deleted.",
      missingVatServiceCode: "Missing subsidiary vat service code",
      missingVatDeductionCode: "Missing subsidiary vat deduction code",
      missingCountryIsoCode: "Missing subsidiary country iso code",
      missingSemiramisOrganizationCode: "Missing subsidiary semiramis organization code",
    },
  },

  manufacturers: {
    delete: "Delete manufacturer",
    edit: "Edit manufacturer",
    new: "New manufacturer",
    singular: "Manufacturer",
    plural: "Manufacturers",
    versions: "Manufacturer versions",

    questions: {
      delete: "Do you really want to delete this manufacturer?",
    },

    errors: {
      nameAlreadyUsed: "A manufacturer with the same name does already exist.",
      inUseByCars: "The manufacturer is still in use by a cars and can't be deleted.",
      inUseByCarOrders: "The manufacturer is still in use by a car orders and can't be deleted.",
    },
  },

  cars: {
    all: "All cars",
    delete: "Delete car",
    edit: "Edit car",
    new: "New car",
    singular: "Car",
    plural: "Cars",
    versions: "Car versions",

    questions: {
      delete: "Do you really want to delete this car?",
    },

    errors: {
      vinAlreadyUsed: "A car with the specified vehicle identification number is already defined.",
      carReadNotAllowed: "Car read not allowed",
    },
  },

  suppliers: {
    delete: "Delete supplier",
    edit: "Edit supplier",
    new: "New supplier",
    singular: "Supplier",
    plural: "Suppliers",
    versions: "Supplier versions",

    questions: {
      delete: "Do you really want to delete this supplier?",
    },

    errors: {
      nameAlreadyUsed: "A supplier with the same name is already defined.",
      inUseByCarOrders: "The supplier is still in use by car orders and can't be deleted.",
    },
  },

  carOrders: {
    all: "All car orders",
    delete: "Delete car order",
    edit: "Edit car order",
    new: "New car order",
    singular: "Car order",
    plural: "Car orders",
    versions: "Car order versions",

    questions: {
      delete: "Do you really want to delete this car order?",
      deleteLinkedPlanning: 'This car order is linked to a car planning. Its status will be reset to "To order".',
    },
    errors: {
      carOrderDateAfterSoldDate: "The car order date cannot be after the sold date.",
    },
  },

  carPlates: {
    delete: "Delete car plate",
    edit: "Edit car plate",
    new: "New car plate",
    singular: "Car plate",
    plural: "Car plates",
    versions: "Car plate versions",

    questions: {
      delete: "Do you really want to delete this car plate?",
    },

    errors: {
      plateOverlapPeriodSub: "The plate number is already in use by another car for the same subsidiary.",
      plateOverlapPeriodCar: "The specifield period overlaps with another plate number.",
      carPlateOutOfSubsidiaryPeriod: "The specified plate period do not fall into subsidiary period.",
    },
  },

  carDrivers: {
    delete: "Delete car driver",
    edit: "Edit car driver",
    new: "New car driver",
    singular: "Car driver",
    plural: "Car drivers",
    versions: "Car driver versions",
    sendMileageEmail: "Send mileage email to the new driver",
    mileageEmailFirstAssignment: "The email can't be sent: this is the first driver of this car.",
    mileageEmailNotificationsDisabled: (flag: string) =>
      `The email can't be sent: the driver has the "${flag}" flag enabled.`,
    mileageEmailNoEmail: "The email can't be sent: this driver has no email address.",

    questions: {
      delete: "Do you really want to delete this car driver?",
    },

    errors: {
      overlapsPeriod: "The specified period overlaps with another car driver.",
      overlapsPeriodPool: "The specified period ovelaps with another of the cal pool.",
      carDriverOutOfSubsidiaryPeriod: "The specified driver period do not fall into subsidiary period.",
      delegationLanguageNotFound: "The selected language is not available for delegations.",
      delegationSubsidiaryNotConfigured:
        "Delegation data are not configured for the subsidiary's semiramis organization code.",
    },
  },

  carLeasings: {
    delete: "Delete car leasing",
    edit: "Edit car leasing",
    conclude: "Conclude car leasing",
    new: "New car leasing",
    singular: "Car leasing",
    plural: "Car leasings",
    versions: "Car leasing versions",

    questions: {
      delete: "Do you really want to delete this car leasing?",
      conclude: "Do you really want to conclude this car leasing?",
    },

    errors: {
      alreadyHasLeasing: "For the specified car a leasing is already defined.",
      expirationDateCantMatchContractDate: "The expiration date can't match the contract date",
      expirationDateCantBeBeforeContractDate: "The expiration date can't be before the contract date",
    },
  },

  mileages: {
    delete: "Delete mileage",
    edit: "Edit mileage",
    new: "New mileage",
    singular: "Mileage",
    plural: "Mileages",
    versions: "Mileage versions",
    sendReminder: "Send mileage reminder",
    sendReminders: "Send reminders",

    questions: {
      delete: "Do you really want to delete this mileage?",
      sendReminder:
        "Do you want to send the current driver an email reminding them to enter the updated mileage of this car?",
    },

    reminderDialog: {
      recipient: "Recipient",
      lastReminder: "Last mileage reminder sent to the driver",
      noReminderSent: "No reminder sent",
      automaticReminderRule:
        "Fleet Manager automatically sends a mileage reminder to the drivers of cars without a mileage in the last 3 months, but skips the drivers who already received one in the last 3 days. If you update the last reminder date, this email counts as the last reminder sent and the driver won't receive the automatic reminder for the next 3 days, even if the 3 months expire in the meantime.",
      updateLastReminder: "Update last reminder date",
      driverNotificationsDisabled: (flag: string) =>
        `The email can't be sent: the driver has the "${flag}" flag enabled.`,
      driverNoEmail: "The email can't be sent: the driver has no email address.",
    },

    remindersDialog: {
      question:
        "Do you want to send the current drivers of the active cars an email reminding them to enter the updated mileage of their car?",
      recipients: "Recipients",
      allDrivers: "All drivers",
      onlyOverdue: "Only overdue mileage (over 3 months)",
      allSubsidiaries: "All subsidiaries",
      summary: (drivers: number, emails: number) =>
        `Drivers to notify: ${drivers} (emails to send: ${emails}, one per car).`,
      excluded: (excluded: number) =>
        `Drivers excluded because they have notifications disabled or no email address: ${excluded}.`,
      noRecipients: "No drivers to notify.",
      onlyOverdueInfo: (option: string) =>
        `With "${option}" only the drivers of cars whose last mileage is older than 3 months or that never had a mileage are notified.`,
      updateLastReminderInfo: (switchLabel: string) =>
        `Fleet Manager also sends an automatic reminder to the drivers with overdue mileage, but skips those who received one in the last 3 days. By enabling "${switchLabel}", the last reminder date of the notified drivers is set to today: for the next 3 days they won't receive the automatic reminder, even if the 3 months expire in the meantime.`,
      backgroundInfo:
        "The reminders are being sent in background: you can close this window and keep working. You will be notified when the sending is over.",
      alreadySending: "Mileage reminders are already being sent: you can start a new sending once it is over.",
      sent: "Mileage reminders sent.",
    },

    notNotifiedDialog: {
      title: "Mileage reminders not sent",
      text: "The mileage reminder could not be sent to the following drivers:",
    },

    errors: {
      mileageWithThisDateAlreadyExists: "or the selected date, the same mileage has already been recorded.",
      distanceLowerPrevRecord: "The inserted mileage is lower than the previous record.",
      distanceHigherNextRecord: "Distance is higher than next record.",
      mileageOutOfSubsidiaryPeriod: "The specified mileage date does not fall into subsidiary period.",
      mileageOutOfCarDriverPeriod: "The mileage date is outside the period in which the car is assigned to you.",
      mileageMustBeBetween: (prevDate: string, prevDistance: string, nextDate: string, nextDistance: string) =>
        `For the selected date, the distance must be between ${prevDistance} (on ${prevDate}) and ${nextDistance} (on ${nextDate}).`,
      mileageMustBeGreater: (distance: string, date: string) =>
        `For the selected date, the distance must be greater than ${distance} (on ${date}).`,
      mileageMustBeLower: (distance: string, date: string) =>
        `For the selected date, the distance must be lower than ${distance} (on ${date}).`,
      reminderMissingCurrentDriver: "The email can't be sent: the car has no current driver.",
      reminderDriverMissingEmail: "The email can't be sent: the driver has no email address.",
      reminderDriverNotificationsDisabled: "The email can't be sent: the driver has notifications disabled.",
      reminderSubsidiaryNotAllowed: "You don't have access to the selected subsidiary.",
    },
  },

  defaultTasks: {
    new: "New default task",
    edit: "Edit default task",
    delete: "Delete default task",
    singular: "Default task",
    plural: "Default tasks",

    questions: {
      delete: "Do you really want to delete this default task?",
    },
  },

  customTasks: {
    set: "Set custom tasks",
    create: "Create custom tasks",
    edit: "Edit custom tasks",
    singular: "Custom task",
    plural: "Custom tasks",

    questions: {
      customize: "The subsidiary is currently using the default tasks. Do you want to customize them?",
    },

    errors: {
      taskAlreadySelected: "The task has already been selected.",
    },
  },

  tasks: {
    delete: "Delete task",
    rename: "Rename task",
    edit: "Edit task",
    new: "New task",
    singular: "Task",
    plural: "Tasks",
    versions: "Task versions",

    questions: {
      delete: "Do you really want to delete this task?",
    },

    errors: {
      taskNameAlreadyExists: "A default task with the same name is already defined.",
      inUseByCustomTasks: "The default task is still in use by a custom task and can't be deleted.",
    },
  },

  tasksCategories: {
    delete: "Delete task category",
    plural: "Task categories",

    questions: {
      deleteSubsidiaryCustomTasks: "Do you really want to delete this custom category and associate the default tasks?",
    },
  },

  carTasks: {
    delete: "Delete car task",
    edit: "Edit car task",
    new: "New car task",
    singular: "Car task",
    plural: "Car tasks",

    questions: {
      delete: "Do you really want to delete this task?",
      deleteWithWorkflow:
        "This task is associated with a workflow. If you proceed, both the task and its related workflow will be deleted. Do you want to continue?",
    },

    errors: {
      inUseByWorkflows: "The car task is still in use by a workflow and can't be deleted.",
    },
  },

  leasingCompanies: {
    delete: "Delete leasing company",
    edit: "Edit leasing company",
    new: "New leasing company",
    singular: "Leasing company",
    plural: "Leasing companies",
    versions: "Leasing company versions",

    questions: {
      delete: "Do you really want to delete this leasing company?",
    },

    errors: {
      nameAlreadyExists: "A leasing company with the same name is already defined.",
      inUseByCarLeasings: "The leasing company is still in use by a car leasing and can't be deleted.",
    },
  },

  plateNumbers: {
    singular: "Plate number",
  },

  highwayPasses: {
    delete: "Delete highway pass",
    edit: "Edit highway pass",
    new: "New highway pass",
    singular: "Highway pass",
    plural: "Highway passes",
    versions: "Highway pass versions",

    questions: {
      delete: "Do you really want to delete this highway pass?",
    },

    errors: {
      highwayPassOverlaps:
        "A highway pass with the same number and for the specified period is already in use by another car.",
      highwayPassOutOfSubsidiaryPeriod: "The specified highway pass period do not fall into subsidiary period.",
    },
  },

  costTypeCategories: {
    delete: "Delete cost type category",
    edit: "Edit cost type category",
    new: "New cost type category",
    singular: "Cost type category",
    plural: "Cost type categories",
    versions: "Cost type category versions",

    questions: {
      delete: "Do you really want to delete this cost type category?",
    },

    errors: {
      isUsedByCostType: "The cost type category is still in use by a cost type and can' be deleted.",
      nameAlreadyUsed: "A cost type category with the same name is already defined.",
    },
  },

  costTypes: {
    delete: "Delete cost type",
    edit: "Edit cost type",
    new: "New cost type",
    singular: "Cost type",
    plural: "Cost types",
    versions: "Cost type versions",

    questions: {
      delete: "Do you really want to delete this cost type?",
    },

    errors: {
      isUsedByCosts: "The cost type is still in use by a cost and can' be deleted.",
      nameAlreadyUsed: "A cost type with the name is already defined.",
    },
  },

  costs: {
    delete: "Delete cost",
    edit: "Edit cost",
    new: "New cost",
    singular: "Cost",
    plural: "Costs",
    versions: "Cost versions",

    questions: {
      delete: "Do you really want to delete this cost?",
    },

    errors: {
      costOutOfSubsidiaryPeriod: "The specified cost date do not fall into subsidiary period.",
      missingCurrency: (currency: string) => `Unable to convert the cost to EUR: currency ${currency} not found.`,
    },
  },

  maintenanceTypes: {
    delete: "Delete maintenance type",
    edit: "Edit maintenance type",
    new: "New maintenance type",
    singular: "Maintenance type",
    plural: "Maintenance types",

    questions: {
      delete: "Do you really want to delete this maintenance type?",
    },

    errors: {
      isUsedByMaintenance: "The maintenance type is still in use by a maintenance record and can't be deleted.",
      nameAlreadyUsed: "A maintenance type with the same name is already defined.",
    },
  },

  maintenance: {
    delete: "Delete maintenance",
    edit: "Edit maintenance",
    new: "New maintenance",
    singular: "Maintenance",
    plural: "Maintenances",

    questions: {
      delete: "Do you really want to delete this maintenance record?",
    },
  },

  costsImport: {
    delete: "Delete cost import",
    changeCarAssignment: "Change associated vehicle",
    changeCarAssignmentDisclaimer: (plate: string, date: string) =>
      `This cost was billed to plate ${plate} on ${date}. Before making any manual changes, please double-check the current data in Fleet Management to make sure this correction is really needed.`,
    noDriverCoversDate: "None of the assignments listed above cover the date of this cost entry.",
    missingAssignmentCostCenter: (name: string) => `${name} covers this cost's date but has no cost center defined.`,
    carForcedManually: (date: string) => `Car was manually assigned on ${date}.`,
    assignmentForcedManually: (date: string) => `Driver assignment was manually forced on ${date}.`,
    carForcedFromTo: (fromPlate: string, toPlate: string, name: string, date: string) =>
      `This car assignment was changed from ${fromPlate} to ${toPlate} by ${name} on ${date}.`,
    removeForcedCar: "Remove override",
    costWillBeAssignedTo: (name: string) => `This cost will be assigned to ${name}.`,
    forceThisDriver: "Force this driver",
    removeAssignment: "Remove assignment",
    forcedAssignmentDoesNotCoverDate: "This assignment does not cover the date of this cost entry.",
    excludedFromExport: (plate: string) =>
      `For ${plate} this line is not exported to costs: only pkw, pkw-superior and lkw cars are exported.`,

    questions: {
      deleteImport: "Do you really want to delete this costs import?",
      importInCosts: "Do you really want to import these lines into costs?",
      forceDriver: (name: string) =>
        `Do you really want to force this cost to be assigned to ${name}? This overrides the automatic date-based assignment.`,
    },

    dkv: {
      noCarFound: (plate: string, date: string) => `For the plate ${plate} no car matches the cost at ${date}`,
      noDriverFound: (plate: string, date: string) => `For the car ${plate} no assignment covers the cost at ${date}`,
      noSubsidiaryVatCodeFound: (productCode: string) => `For ${productCode} no subsidiary VAT code found`,
      noCostTypeFound: (productCode: string, category?: string) =>
        `For ${productCode}${category ? `/${category}` : ""} no cost type found`,
      noCostCenterFound: (name: string, date: string) => `For ${name} no cost center covers the cost at ${date}`,
      noUserCostCenterFound: (plate: string, date: string) =>
        `For the car ${plate} no user cost center covers the cost at ${date}`,

      errors: {
        columnTargaVeicolo: "Column 'Targa veicolo' not found",
        columnDataFattura: "Column 'Data della fattura' not found",
        columnOraTransazione: "Column 'Ora transazione' not found",
        columnValoreBaseNetto: "Column 'Valore base netto' not found",
        columnValoreBaseLordo: "Column 'Valore base lordo' not found",
        columnCodiceMerce: "Column 'Codice merce' not found",
        columnGruppoProdotti: "Column 'Gruppo di prodotti' not found",
        columnTipoMerce: "Column 'Tipo di merce' not found",
        columnPaesePedaggio: "Column 'Paese di pedaggio' not found",
        columnIva: "Column 'IVA' not found",
        columnScontoNetto: "Column 'Sconto netto' not found",
        columnScontoLordo: "Column 'Sconto lordo' not found",
        columnServiceFeeNetto: "Column 'Service fee netto' not found",
        columnQuantita: "Column 'Quantità' not found",
        columnUnita: "Column 'Unità' not found",
      },
    },

    dkvTolls: {
      errors: {
        columnDataFattura: "Column 'Data della fattura' not found",
        columnTargaVeicolo: "Column 'Targa veicolo' not found",
        columnOraUscita: "Column 'Ora uscita' not found",
        columnCodiceMerce: "Column 'Codice merce' not found",
        columnValutaServizio: "Column 'Valuta del servizio' not found",
        columnIva: "Column 'IVA' not found",
        columnValoreBaseNetto: "Column 'Valore base netto' not found",
        columnPaesePedaggio: "Column 'Paese di pedaggio' not found",
      },
    },
  },

  dueDateTypes: {
    delete: "Delete due date type",
    edit: "Edit due date type",
    new: "New due date type",
    singular: "Due date type",
    plural: "Due date types",
    versions: "Due date type versions",

    questions: {
      delete: "Do you really want to delete this due date type?",
    },

    errors: {
      isUsedByDueDates: "The due date type is still in use by a due date and can't be deleted",
      nameAlreadyUsed: "A due date type with the same name is already defined.",
    },
  },

  dueDates: {
    all: "All Due Dates",
    delete: "Delete due date",
    edit: "Edit due date",
    new: "New due date",
    singular: "Due date",
    plural: "Due dates",
    versions: "Due date versions",
    renewPlural: "Renew due dates",
    renewSingular: "Renew due date",
    renewSelected: "Renew selected due dates",
    setSettledSelected: "Set selected due dates as settled",

    questions: {
      delete: "Do you really want to delete this due date?",
      setSettled: "Do you really want to set the selected due dates as settled?",
    },

    errors: {
      dueDateOutOfSubsidiaryPeriod: "The specified due date do not fall into subsidiary period.",
    },
  },

  documents: {
    add: "Add document",
    all: "All documents",
    alreadyPresent: "Document already present.",
    plural: "Documents",
    delete: "Delete document",
    search: "Search documents",

    questions: {
      delete: "Do you really want to delete this document?",
      overwrite: "Do you want to overwrite the already present document?",
    },

    errors: {
      notFound: "The document was not found",
    },
  },

  users: {
    all: "All users",
    delete: "Delete user",
    edit: "Edit user",
    new: "New user",
    singular: "User",
    plural: "Users",

    questions: {
      delete: "Do you really want to delete this user?",
    },

    errors: {
      noMatchingUserFound: "No matching user found.",
      rothoblaasUserWithEmailNotFound: "A Rothoblaas user with the specified email was not found.",
      usersWithEmailAlreadyExists: "A user with the specified email is already defined.",
      usersWithEmailNotFound: "A user with the specified email was not found.",
      inUseByCarTasks: "The user is still in use by a car task and can't be deleted.",
      inUseByCarOrders: "The user is still in use by a car order and can't be deleted.",
      inUseByCarDrivers: "The user is still in use by a driver and can't be deleted.",
      invalidEmailDomain: "The email domain is invalid for rothoblaas users.",
      userSubsidiaryAlreadyExists: "The user is already assigned to specified subsidiary.",
      userInUseAsManager: "The user is still in use as a manager and can't be deleted.",
    },
  },

  claims: {
    all: "All claims",
    delete: "Delete claim",
    edit: "Edit claim",
    new: "New claim",
    singular: "Claim",
    plural: "Claims",
    incidentDate: "Incident date",
    openingDate: "Opening date",
    closingDate: "Closing date",
    damageValue: "Damage value",
    settledAmount: "Settled amount",

    questions: {
      delete: "Do you really want to delete this claim?",
      switchDriver: (selectedDriver: string, currentDriver: string) =>
        `The selected driver is ${selectedDriver} but the current assigend one is ${currentDriver}.<br /> Do you want to assign this claim to ${currentDriver}?`,
      switchSubsidiary: (selectedSubsidiary: string, currentSubsidiary: string) =>
        `The selected subsidiary is ${selectedSubsidiary} but the current assigned one is ${currentSubsidiary}.<br /> Do you want to assign this claim to ${currentSubsidiary}?`,
    },
  },

  fines: {
    delete: "Delete fine",
    edit: "Edit fine",
    new: "New fine",
    singular: "Fine",
    plural: "Fines",
    verbalNumber: "Verbal number",
    violationDate: "Violation date",
    communicationDate: "Communication date",
    firstNotificationDate: "First notification date",
    amount: "Amount",
    points: "Points",
    accountant: "Accountant",
    hrReferent: "HR referent",
    notifyDriver: "Notify driver",
    archive: "Archive",
    notifications: "Notifications",
    sentBy: "Sent by",
    sentAt: "Sent at",
    notifyDialog: {
      recipient: "Recipient",
      attachments: "Attachments",
      noAttachments: "Select at least one document to send.",
      addDocuments: "Add documents",
      dropDocumentsHint: "You can also drop the files on the table",
      attachmentsHint: "Documents added here are also saved in the fine's documents.",
      alreadyNotified: (name: string, date: string) => `Already notified by ${name} on ${date}.`,
      driverNotificationsDisabled: (flag: string) =>
        `The email can't be sent: the driver has the "${flag}" flag enabled.`,
      driverNoEmail: "The email can't be sent: the driver has no email address.",
      userNotificationsDisabled: (flag: string) =>
        `This user has the "${flag}" flag enabled and can't receive the copy.`,
      userNoEmail: "This user has no email address and can't receive the copy.",
    },
    errors: {
      notifyArchived: "An archived fine can't be notified.",
      alreadyArchived: "The fine is already archived.",
      driverMissingEmail: "The email can't be sent: the driver has no email address.",
      driverNotificationsDisabled: "The email can't be sent: the driver has notifications disabled.",
    },
    statuses: {
      new: "New",
      notified: "Notified",
      archived: "Archived",
    },
    questions: {
      delete: "Do you really want to delete this fine?",
      archive: "Do you really want to archive this fine?",
    },
  },

  claimTypes: {
    all: "All claim types",
    delete: "Delete claim type",
    edit: "Edit claim type",
    new: "New claim type",
    singular: "Claim type",
    plural: "Claim types",

    questions: {
      delete: "Do you really want to delete this claim type?",
    },

    errors: {
      nameAlreadyUsed: "A claim type with this name already exists",
      inUseByClaims: "The claim type is still in use by claims and can't be deleted.",
    },
  },

  clients: {
    all: "All clients",
    plural: "Clients",
    createNew: "Create new client",
    delete: "Delete client",
    search: "Search clients",

    questions: {
      delete: "Do you really want to delete this client?",
    },

    errors: {
      notFound: "Client not found.",
      missingName: "Client name is missing.",
      insertNotAllowed: "You are not allowed to insert a new client.",
      readNotAllowed: "You are not allowed to read this client.",
      updateNotAllowed: "You are not allowed to update this client.",
      deleteNotAllowed: "You are not allowed to delete this client.",
    },
  },

  subsidiaryVatCodes: {
    delete: "Delete subsidiary VAT code",
    edit: "Edit subsidiary VAT code",
    new: "New subsidiary VAT code",
    singular: "Subsidiary VAT code",
    plural: "Subsidiary VAT code",
    versions: "Subsidiary VAT code versions",

    questions: {
      delete: "Do you really want to delete this subsidiary VAT code?",
    },
  },

  roles: {
    delete: "Delete Role",
    edit: "Edit Role",
    new: "New Role",
    singular: "Role",
    plural: "Roles",

    questions: {
      delete: "Do you really want to delete this Role?",
    },
  },

  permissions: {
    plural: "Permissions",
  },

  secrets: {
    plural: "Secrets",

    errors: {
      missingName: "Secret name is missing.",
      missingValue: "Secret value is missing.",
    },
  },

  carPoolCostCenters: {
    delete: "Delete Car Pool Cost Center",
    edit: "Edit Car Pool Cost Center",
    new: "New Car Pool Cost Center",
    singular: "Car Pool Cost Center",
    plural: "Car Pool Cost Centers",

    questions: {
      delete: "Do you really want to delete this Car Pool Cost Center?",
    },

    errors: {
      carPoolOverlapPeriod: "Car pool already has a cost center in this period",
    },
  },

  otherCarAssignments: {
    delete: "Delete Other Car Assignment",
    edit: "Edit Other Car Assignment",
    new: "New Other Car Assignment",
    singular: "Other Car Assignment",
    plural: "Other Car Assignments",

    questions: {
      delete: "Do you really want to delete this Other Car Assignment?",
    },

    errors: {
      carPoolOverlapPeriod: "Car is already in car pool for this period",
      carPoolOverlapPeriodWithDrivers: "Car already has a driver in this period",
      assignmentOutOfSubsidiaryPeriod: "The specified assignment period do not fall into subsidiary period.",
    },
  },

  carPlannings: {
    delete: "Delete Car Planning",
    edit: "Edit Car Planning",
    new: "New Car Planning",
    singular: "Car Planning",
    plural: "Car Plannings",
    versions: "Car Planning Versions",

    questions: {
      delete: "Do you really want to delete this Car Planning?",
    },

    errors: {
      missingSemiramisCode:
        "Subsidiary without semiramis organization code. Please set the semiramis code in the subsidiary selected",
    },
  },

  carSubsidiaries: {
    delete: "Delete Car Subsidiary",
    edit: "Edit Car Subsidiary",
    new: "New Car Subsidiary",
    singular: "Car Subsidiary",
    plural: "Car Subsidiaries",
    versions: "Car Subsidiary Versions",

    questions: {
      delete: "Do you really want to delete this Car Subsidiary?",
    },

    errors: {
      overlapPeriodCarSubsidiary: "The specifield period overlaps with another subsidiary.",
      overlapPeriodCarPlate: "There are subsidiary car plates which overlap other subsidiaries period as well.",
      overlapPeriodCarDriver: "There are subsidiary car drivers which overlap other subsidiaries period as well.",
    },
  },

  rentalCars: {
    delete: "Delete rental car",
    edit: "Edit rental car",
    new: "New rental car",
    singular: "Rental car",
    plural: "Rental cars",

    questions: {
      delete: "Do you really want to delete this rental car?",
    },

    errors: {
      overlapPeriodCar: "The specifield period overlaps with another rental car.",
    },
  },

  userSubsidiaries: {
    delete: "Delete user subsidiary",
    edit: "Edit user subsidiary",
    new: "New user subsidiary",
    singular: "User subsidiary",
    plural: "User subsidiaries",
    versions: "User subsidiary versions",

    questions: {
      delete: "Do you really want to delete this user subsidiary?",
    },
  },

  userRoles: {
    delete: "Delete user role",
    edit: "Edit user role",
    new: "New user role",
    singular: "User role",
    plural: "User roles",
    versions: "User role versions",

    questions: {
      delete: "Do you really want to delete this user role?",
    },

    errors: {
      alreadyExists: "User role already exists",
    },
  },

  common: {
    acceptImages: "Accept images",
    acceptImagesDialog: "The uploaded images will be accepted, and the driver will be notified by email.",
    accessNotAllowed: "Access not allowed",
    accessNotAllowedError: "You do not have permission to view this page.",
    active: "Active",
    action: "Action",
    accounting: "Accounting",
    add: "Add",
    addCustomTask: "Add custom task",
    addDefaultTask: "Add default task",
    addCustomCarTask: "Add custom car task",
    addDefaultCarTask: "Add default car task",
    addDueDate: "Add Due Date",
    addNew: "Add new",
    addNewAssignment: "Add New Assignment",
    addMileage: "Add Mileage",
    address: "Address",
    addTask: "Add Task",
    addToCarPool: "Add to car pool",
    addToHistory: "Add to History",
    admin: "Admin",
    administration: "Administration",
    agreement: "Agreement",
    all: "All",
    allowCarsToHaveMultiplePlates: "Allow cars to have multiple plates",
    allowMultiplePlates: "Allow multiple plates",
    alreadyInCarPool: "Car already in car pool",
    alreadyPresent: "Already present",
    alreadyUpdated: "This record has been updated by another user. Refresh the page to get the latest version.",
    areaSalesManager: "Area sales manager",
    arrived: "Arrived",
    arrivingSoon: "Arriving soon",
    ascending: "Ascending",
    assign: "Assign",
    assignCar: "Assign Car",
    assignHp: "Assign New Highway Pass",
    assignNewDriver: "Assign New Driver",
    assignNewPlate: "Assign New Plate",
    assigned: "Assigned",
    assignedTo: "Assigned to",
    assignSubsidiary: "Assign Subsidiary",
    awaitingForApproval: "Awaiting for approval",
    attachments: "Attachments",
    attachmentsHelpDialog:
      "It is possible to attach images and/or documents; the uploaded files will be visible to you and to the Fleet Manager system administrators.",
    avgYears: "Ø years",
    back: "Back",
    birthdate: "Birth date",
    business: "Business",
    by: "By",
    cancel: "Cancel",
    cancelled: "Cancelled",
    cancelWorkflow: "Cancel workflow",
    cancelWorkflowRequest:
      "The workflow will be stopped. Any pending image uploads will be cancelled. Do you want to proceed?",
    car: "Car",
    carAssignment: "Car Assignment",
    carCategory: "Car Category",
    carInCarPool: "Car in Car Pool",
    carNotInUse: "Car not in use",
    carPool: "Car Pool",
    carPoolCostCenters: "Car Pool Cost Centers",
    carOrdersWithNearTermText: {
      prefix: "There are some car orders with near arrival date that are not yet assigned. Click ",
      linkTitle: "here",
      suffix: " to list and fix them.",
    },
    carReplacedRental: "Rental replacement car",
    cartax: "Cartax",
    carVin: "Car (Vin)",
    categories: "Categories",
    category: "Category",
    changeFlag: "Change Flag",
    checkWorkflow: "Check workflow",
    clear: "Clear",
    close: "Close",
    closed: "Closed",
    awaitingDocuments: "Awaiting documents",
    closingDate: "Closing date",
    columnNotFilterable: "This column is not filterable",
    columnNotSortable: "This column is not sortable",
    filterEquals: "Equals",
    filterRange: "From - To",
    filterMonth: "Month",
    continue: "Continue",
    contractDate: "Contract Date",
    contractDetails: "Contract Details",
    cost: "Cost",
    costInputFormNet: "Cost (Net - Currency)",
    countDate: "Count Date",
    country: "Country",
    countryIsoCode: "Country Iso Code",
    countryIsoCodeRequiredForAgreement:
      "The creation of a agreement requires the subsidiary country iso code to be set.",
    costCenter: "Cost center",
    costCenterHistory: "Cost center history",
    costObject: "Cost object",
    costImport: "Cost Import",
    costImports: "Cost Imports",
    costGross: "Cost Gross",
    costNet: "Cost Net",
    co2: "Co2",
    create: "Create",
    createdAt: "Created at",
    createdBy: "Created by",
    createDelegation: "Create delegation",
    createDelegationWithDriverSelection: "Create delegation with driver selection",
    createDelegationForExternal: "Create delegation for external people",
    createNew: "Create new",
    currency: "Currency",
    currentHighwayPass: "Current Highway Pass",
    currentDriver: "Current Driver",
    currentlyInCarPool: "This car is currently in car pool.",
    currentlyNotUsed: "This car is currently not in use.",
    currentlyAssignToDriver: "This car is currently assigned to another driver.",
    currentPlateNumber: "Current plate number",
    currentSubsidiary: "Current Subsidiary",
    currentVersion: "Current version",
    dashboard: "Dashboard",
    dataConflicts: (value: string) => `Data conflicts on date ${value}`,
    dataHasBeenSavedSuccessfully: "Data has been saved succesfully.",
    dataHasBeenUpdatedSuccesfully: "Data has been updated successfully.",
    date: "Date",
    datePicker: {
      clearButton: "Clear date",
      nextMonth: "Next month",
      placeholder: "Select date",
      previousMonth: "Previous month",
      selectMonth: "Select month",
      selectYear: "Select year",
    },
    decrease: (value: number) => `Decrease ${value}`,
    defaultCurrency: "Default currency",
    defaultLanguage: "Default language",
    delegation: "Delegation",
    delete: "Delete",
    deleteFilter: (filter: string) => `Delete filters for ${filter}`,
    deleteFilters: "Delete filters",
    department: "Department",
    departments: "Departments",
    descending: "Descending",
    description: "Description",
    diesel: "Diesel",
    discountGross: "Discount Gross",
    discountNet: "Discount Net",
    distance: "Distance",
    distances: "Distances",
    distanceInMiles: "Distance in Miles",
    divisionSalesManager: "Division sales manager",
    dkvProductCodes: "Dkv Product Codes",
    documents: "Documents",
    done: "Done",
    download: "Download",
    downloadFile: "Download File",
    dragAndDropOrUploadAnImage: "Drag and Drop or click to upload an image",
    driverAlreadyNotified: "A notification email has already been sent to this user. Would you like to resend it?",
    driverNotified: (on: string) => `Driver notified on ${on}. Waiting for images to be uploaded.`,
    dragAndDropOrUploadAnFile: "Drag and Drop or click to upload a file",
    driverName: "Driver name",
    driverSince: "Driver since",
    drivingLicenseExpirationDate: "Driving license expiration date",
    drivingLicenseText:
      "By entering your drivers license expiration date into the system, you will automatically receive a reminder notification approximately 20 days before the expiration. The information entered is neither tracked nor managed by Fleet Management, but is processed exclusively by the system.",
    dropIt: "Drop it",
    dueDateHelpDialog: "By entering a date, the expiration will be updated to the selected date.",
    dueDateVisibleToUser: "Selecting a user makes the due date visible to both the user and the associated managers.",
    edit: "Edit",
    editedBy: "Edited by",
    editNotPermitted: "Editing is no longer permitted — more than one day has passed since creation.",
    electric: "Electric",
    email: "Email",
    emailSendToDriver: "An email notification will be sent to the driver.",
    empty: "Empty",
    endDate: "End Date",
    engineCapacity: "Engine capacity",
    english: "English",
    englishUk: "English - UK",
    englishUs: "English - US",
    englishBrasil: "English - Brasil",
    enteredDate: "Entered date",
    enterAPhoneNumber: "Please enter a phone number",
    enterValidNames: "Please enter valid names.",
    error: "Error",
    errorLoadingData: "Error loading data",
    expirationDate: "Expiration Date",
    expired: "Expired",
    expiringSoon: "Expiring soon",
    exportExcel: "Export Excel",
    fieldCannotBeEmpty: "The field cannot be empty.",
    file: "File",
    fileCsv: "File csv",
    fileNotSupported: `The file is not supported.`,
    fileTypeSupported: (extensions: string[]) => `File types supported: ${extensions.join(", ")}.`,
    fileToLarge: "File to large",
    fiscalPrice: "Fiscal Price",
    fieldContainsInvalidValueInsertBiggerOne: "The field contains an invalid value, insert a bigger one.",
    fieldContainsInvalidValueInsertSmallerOne: "The field contains an invalid value, insert a smaller one.",
    fieldInvalidValue: "The field contains an invalid value.",
    fieldValueInvalidFormat: "The value has an invalid format.",
    firstName: "First name",
    flag: "Flag",
    french: "French",
    fringeBenefit: "Fringe benefit",
    from: "From",
    fuelCard: "Fuel card",
    fuelType: "Fuel Type",
    gasoline: "Gasoline",
    generalData: "General data",
    generateAgreement: "Generate agreement",
    genericError: "An error has occurred, please try again.",
    german: "German",
    gpl: "Gpl",
    hasImportErrors: "Has import errors",
    hideToUser: "Hide to User",
    hidden: "Hidden",
    hiddenText:
      "Since users are regularly imported from the Rothoblaas system, some accounts might not be needed in the management system. This flag allows hiding a user from the driver management.",
    disableNotifications: "Disable notifications",
    disableNotificationsText:
      "If this flag is enabled, automatic notification emails will not be sent. Other emails triggered by user actions will still be sent.",
    hideArrivalNotification: "Hide arrival date notification",
    history: "History",
    hp: "Hp",
    hybrid: "Hybrid",
    imagesAccepted: "Images accepted",
    imagesDeleted: "Images deleted",
    imagesSupplied: "Images supplied",
    imperial: "Imperial (miles)",
    importInCosts: "Import in Costs",
    import: "Import",
    importCsv: "Import Csv",
    importErrors: "Import errors",
    importErrorsText:
      "The cost centers are automatically imported from bValue (Provisius).<br/>The lines below indicate records that could not be imported.<br/>Please check the from/to dates with HR and correct them below.",
    importDkv: "Import Dkv",
    importHighwayToll: "Import Highway Tolls",
    importedInCosts: "Imported in costs",
    increase: (value: number) => `Increase ${value}`,
    insert: "Insert",
    insurance: "Insurance",
    invalidDate: "Invalid Date",
    invalidLenght: "Invalid lenght",
    invalidNumber: "Invalid number",
    isInPool: "Is in pool",
    isRothoblaasUser: "Is Rothoblaas user",
    isRothoblaasUserTexts: [
      "This flag is used to distinguish Rothoblaas users from external users. When it is enabled, the system verifies that the email address is valid. If so, the first name and last name are retrieved from the Rothoblaas database. Additionally, it is not possible to save a user with a Rothoblaas email address if there is no matching active user.",
      "With the flag disabled, the email address remains optional and no checks are performed on Rothoblaas users. In this case, however, first and last name become mandatory.",
    ],
    isSettled: "Is Settled",
    italian: "Italian",
    portuguese: "Portuguese",
    withErrors: "With errors",
    withoutErrors: "Without errors",
    itemsNotExported: "No exports",
    itemsForced: "Forced",
    forcedBy: "Forced by",
    keep: "Keep",
    kilometers: "Kilometers",
    language: "Language",
    languageCode: "Language code",
    lastDriver: "Last Driver",
    lastEdit: "Last edit by",
    lastHighwayPass: "Last Highway Pass",
    lastMileage: "Last Mileage",
    lastMileageRec: "Last Mileage record",
    lastName: "Last name",
    lastPlate: "Last Plate Number",
    lastRecord: "Last record",
    lastUpdate: "Last update",
    lastUpdatedBy: "Last updated by",
    latvian: "Latvian",
    leasing: "Leasing",
    lessThanDueDateRecord: "is less than one selected record date",
    licensePlateValidityEnd: "License validity end",
    licensePlateValidityStart: "License validity start",
    lithuanian: "Lithuanian",
    loading: "Loading",
    logout: "Logout",
    lkw: "Lkw",
    lkwAccountingNumber: "Lkw Accounting Number",
    lkwAccountingNumberShort: "Lkw Acc.Nr.",
    manageCategories: "Manage categories",
    manageClaimTypes: "Manage claim types",
    manageCostTypeCategories: "Manage cost type categories",
    manageCostTypes: "Manage cost types",
    vatCodes: "VAT codes",
    manageDefaultTasks: "Manage default tasks",
    manageDueDateTypes: "Manage due date types",
    manageMaintenanceTypes: "Manage maintenance types",
    manager: "Manager",
    managerEmail: "Manager email",
    managerName: "Manager name",
    metric: "Metric (km)",
    mileage: "Mileage",
    mileages: "Mileages",
    miles: "miles",
    missingContractDate: "Missing contract date",
    missingCountry: "Missing country",
    missingExpirationDate: "Missing expiration date",
    missingLeasingCompany: "Missing leasing company",
    missingRenewalDate:
      "Warning! No renewal date has been entered; the expiration will not be updated and will simply be closed.",
    modifiedAt: "Modified at",
    modifiedBy: "Modified by",
    model: "Model",
    monthYearPicker: {
      clearButton: "Clear month",
      nextYear: "Next year",
      placeholder: "Select month",
      previousYear: "Previous year",
      selectYear: "Select year",
    },
    myArea: "My Area",
    myCar: "My Car",
    myCars: "My Cars",
    myProfile: "My Profile",
    myTeamCar: "My Team Car",
    myTeamCars: "My Team Cars",
    name: "Name",
    needsAttention: "Needs attention",
    nextNRows: (n: number) => `Next ${n} rows`,
    newLeasing: "New Leasing",
    newPlateNumber: "New Plate Number",
    newOrder: "New Order",
    no: "No",
    noDriver: "No Driver",
    noFileSelected: "No file selected",
    noHighwayPasses: "No Highway Passes",
    noDueDate: "No Due Dates",
    noDueDateSelected: "No due date selected",
    noItemsFound: "No items found.",
    noLeasing: "No Leasing",
    noMilegaes: "No Mileages",
    notes: "Notes",
    noTasksToDo: "No Tasks to do",
    notFound: "Not found",
    notifications: "Notifications",
    notifyDriver: "Notify driver",
    notInUse: "Not in use",
    notPlannedPurchase: "Not Planned Purchase",
    notRequired: "Not Required",
    notSettled: "Not Settled",
    number: "Number",
    count: "Count",
    open: "Open",
    ok: "Ok",
    on: "on",
    openingDate: "Opening date",
    operation: "Operation",
    optional: "Optional",
    optionals: "Optionals",
    order: "Order",
    orderImperativ: "Order",
    ordersWithNearArrivalDate: "Car orders with near arrival date",
    orderCar: "Order Car",
    orderDate: "Order date",
    ordered: "Ordered",
    overview: "Overview",
    overwrite: "Overwrite",
    otherAssignmentType: "Car Pool / Not in use",
    others: "Others",
    parking: "Parking",
    permissions: "Permissions",
    phoneNumber: "Phone number",
    phoneNumberIsInvalid: "Phone number is invalid with this country",
    picture: "Picture",
    plannedArrivalDate: "Planned arrival date",
    plugInHybrid: "Plug-in Hybrid",
    pkw: "Pkw",
    pkwAccountingNumber: "Pkw Accounting Number",
    pkwAccountingNumberShort: "Pkw Acc.Nr.",
    pkwSuperior: "Pkw Superior",
    pkwSuperiorAccountingNumber: "Pkw Superior Accounting Number",
    pkwSuperiorAccountingNumberShort: "Pkw Sup. Acc.Nr.",
    pkwUp: "Pkw Up",
    pkwUpAccountingNumber: "Pkw Up Accounting Number",
    pkwUpAccountingNumberShort: "Pkw Up Acc.Nr.",
    positionName: "Position Name",
    positionCode: "Position Code",
    preferredLanguage: "Preferred language",
    preview: "Preview",
    previousEndDateLowerStartDate: "Please enter an end date for the previous record later than its start date.",
    previousEndDateUndefined: "Please set an end date for the previous record.",
    previousNRows: (n: number) => `Previous ${n} rows`,
    purchasePriceInputForm: "Purchase price (without VAT - with VAT - currency)",
    priceWithVat: "Price with VAT",
    priceWithoutVat: "Price without VAT",
    pricePerUnit: "Price per unit",
    private: "Private",
    privateCar: "Private Car",
    productCategory: "Product Category",
    productCode: "Product Code",
    productType: "Product Type",
    purchase: "Purchase",
    purchaseDate: "Purchase Date",
    purchaseType: "Purchase / Leasing",
    quantity: "Quantity",
    read: "Read",
    reAssignment: "Re-Assignment",
    recipient: "Recipient",
    resourceNotFound: "The resource you are looking for has not been found.",
    responsible: "Responsible",
    responsibleCode: "Responsible code",
    returned: "Returned to leasing",
    regionSalesManager: "Region sales manager",
    registrationDate: "Registration Date",
    rejectImages: "Reject images",
    rejected: "Rejected",
    rejectImagesForm:
      "The uploaded images will be rejected and deleted. The driver will be notified by email that new images are required. You may provide a message to include in the email:",
    reloadData: "Reload data",
    remove: "Remove",
    rename: "Rename",
    renameDocument: "Rename document",
    reopen: "Reopen",
    reopenWorkflow: "Reopen workflow",
    renewalDate: "Renewal date",
    roles: "Roles",
    rolesAndPermissions: "Roles and permissions",
    salesRole: "Sales role",
    save: "Save",
    saving: "Saving",
    search: "Search",
    select: "Select",
    selectAll: "Select all",
    selectACountry: "Please select a country",
    selectDate: "Select Date",
    selectFile: "Select File",
    selectFlag: "Select Flag",
    semiramisOrganizationCode: "Semiramis organization code",
    sendDelegation: "Send Delegation",
    send: "Send",
    sendEmail: "Send email",
    setAsDone: "Set as done",
    inProgress: "In progress",
    setAsNotRequired: "Set as not required",
    setAsTodo: "Set as to do",
    setIsoCode: "Set Iso Code",
    setNotInUse: "Set not in use",
    setSubsidiaryIsoCode: "Set subsidiary iso code",
    settings: "Settings",
    settled: "Settled",
    setToday: "Set today",
    showArrivalNotification: "Show arrival date notification",
    showToUser: "Show to User",
    sold: "Sold",
    someCostCenterPeriodsOverlap: "Some cost center periods do overlap.",
    sortAscending: "Sort ascending",
    sortDescending: "Sort descending",
    spanish: "Spanish",
    startDate: "Start Date",
    startDateBeforeEndDatePrevRecord: "Please enter a start date later than the previous end date.",
    startDateEqualEndDate: "Please enter a start date earlier than the end date.",
    startDateEqualPrevEndDate: "Start date equal to end date of the previous record",
    startDistance: "Start Distance",
    state: "State",
    serviceFeeNet: "Service fee net",
    serviceFeeGross: "Service fee gross",
    since: "Since",
    soldDate: "Sold date",
    subsidiaryRequiredForAgreement:
      "The creation of the agreement requires the association of the car with a subsidiary.",
    subsidiaryRequiredForDelegation:
      "The creation of a delegation requires the association of the car with a subsidiary.",
    subsidiaryHasCustomTasks: "Subsidiary has custom tasks",
    subsidiaryUsesDefaultTasks: "Subsidiary uses default tasks",
    tasks: "Tasks",
    taskCancelled: "Task cancelled - no action required",
    teamCar: "Team car",
    teamMembers: "Team members",
    technicalSale: "Technical salesman",
    telepass: "Telepass",
    testEnvironment: "Test environment",
    time: "Time",
    to: "To",
    toApprove: "To approve",
    toAssign: "To assign",
    todo: "To do",
    tolls: "Tolls",
    toOrder: "To order",
    total: "Total",
    type: "Type",
    typeOfUse: "Type of use",
    unassigned: "Unassigned",
    unit: "Unit",
    until: "Until",
    userCostCenters: "User cost centers",
    userCostCentersHasImportErrorsText: {
      prefix: "The users cost centers import from bValue (Provisius) contains errors. Click",
      linkTitle: "here",
      suffix: "to list and fix them.",
    },
    usersWithImportErrors: "Users with import errors",
    userWithoutCostCenter: "User without cost center",
    update: "Update",
    uploadedAt: "Uploaded at",
    uploadedBy: "Uploaded by",
    uploadImages: "Upload images",
    uploadImagesRequired: "Upload images required",
    vat: "VAT",
    vatCode: "VAT code",
    vatDeductionCode: "VAT deduction code",
    vatServiceCode: "VAT service code",
    vehicleIdentificationNumber: "Vehicle identification number",
    version: "Version",
    versions: "Versions",
    versionNumber: "Version number",
    viewImages: "View images",
    visibleToUser: "Visible to user",
    waitingForImageApproval: "Waiting for image approval",
    waitingUser: "Waiting user",
    visibleToUserInfo:
      "This field allows you to select a user to share the due date with. By default, the user currently assigned to the car is available for selection. If the due date was previously shared with a different user, both the currently assigned user and the previously shared user will be selectable.",
    view: "View",
    warningCloseEntities: (from: string, to: string) =>
      `The defined period (${from}-${to}) conflicts with other records. By confirming, ${to} will be applied as the end date for the records listed above.`,
    warningReOpenEntities: (from: string, to: string) =>
      `The selected period (${from}-${to}) conflicts with other records. Select the checkboxes for the records you want to carry over to the new subsidiary. By confirming, ${to} will be applied as the end date for the selected records and as the start date for the new ones.`,
    when: "When",
    workflowCancelled: "Workflow cancelled. You can reopen it using the button below.",
    workflowImages: "Workflow images",
    year: "Year",
    yes: "Yes",

    endDateCantMatchStartDate: "The end date can't match the start date",
    endDateBeforeStartDate: "The end date can't be before start date",
    endDateAfterCurrentAssignmentStartDate: "The end date can't be after the current assignment start date",
    startDateFallsInCurrentAssignmentPeriod: "Start date falls in current assignment period",
    endDateFallsInCurrentAssignmentPeriod: "End date falls in current assignment period",
    endDateAfterStartDateNextRec: "Please enter an end date earlier than the start date of the next record.",
    endDateEqualNextStartDate: "End date equal to start date of the next record",
  },
};
export default en;
